// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { nijobs as baseNijobsTheme } from "@stepstone-genesis/design-tokens";
var nijobs = extendBaseTheme("nijobs", baseNijobsTheme);
export {
  nijobs
};
